import SV from 'server-vars';
import { LOCALE_US } from 'dibs-intl/exports/locales';
import { trackEcommerce, trackingConstants, eventNameConstants } from 'dibs-tracking';

// types
import { Item } from './PdpRespSharedItemsRefetchCarouselConfig';

export const trackCarouselImpressions = (
    items: Item[],
    { list, startingIndex }: { list: string; startingIndex: number }
): void => {
    const productList = items.map((item, index) => {
        const { ecommerceTrackingParams, categoryCode, categoryPath } = item || {};
        return {
            ...ecommerceTrackingParams,
            category: categoryPath,
            categoryCode,
            list,
            position: Math.floor(startingIndex + index),
        };
    });

    trackEcommerce({
        type: trackingConstants.ECOM_PRODUCT_IMPRESSION,
        eventName: eventNameConstants.EVENT_VIEW_ITEM_LIST,
        actionField: { list },
        products: productList,
    });
};

export const trackCarouselTileClick = (
    item: Item,
    { list, index }: { list: string; index: number }
): void => {
    const { browseUrl, categoryCode, ecommerceTrackingParams, title } = item || {};

    trackEcommerce({
        type: trackingConstants.ECOM_PRODUCT_CLICK,
        eventName: eventNameConstants.EVENT_SELECT_ITEM,
        products: [
            {
                position: index + 1,
                category: browseUrl || '',
                categoryCode: categoryCode || '',
                ...(ecommerceTrackingParams || {}),
                name: SV.get('locale') === LOCALE_US ? title : 'n/a',
            },
        ],
        actionField: { list, itemId: item?.serviceId },
    });
};
